import Swal from "sweetalert2";

/**
 * Muestra una notificación tipo Toast (no bloqueante, esquina superior derecha)
 * ideal para confirmaciones rápidas y retroalimentación ágil.
 * 
 * @param {string} mensaje - Texto o título de la notificación
 * @param {'success'|'error'|'warning'|'info'|'question'} icono - Ícono de la notificación
 * @param {number} timer - Tiempo en ms antes de cerrarse automáticamente (default: 2500ms)
 */
export const mostrarToast = (mensaje, icono = "success", timer = 2500) => {
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: timer,
    timerProgressBar: true,
    customClass: {
      popup: "animated fadeInDown",
    },
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  return Toast.fire({
    icon: icono,
    title: mensaje,
  });
};
